module.exports = __webpack_public_path__ + "static/media/Icon-metro-calendar.77419203.svg";